import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useClickOutside, useDebouncedCallback, useDisclosure } from "@mantine/hooks";
import colorString from "color-string";
import { ColorPicker, TextInput, Group, ActionIcon, Popover, Text, Select, Stack, } from "@mantine/core";
function detectFormat(color) {
    if (color.startsWith("#")) {
        return "hex";
    }
    if (color.startsWith("rgba")) {
        return "rgba";
    }
    if (color.startsWith("rgb")) {
        return "rgb";
    }
    if (color.startsWith("hsla")) {
        return "hsla";
    }
    return "hsl";
}
export function ColorInput({ value, onChange, label, disabled, debounce = 200 }) {
    const [opened, { close, toggle }] = useDisclosure(false);
    const dropdownRef = useClickOutside(close);
    const [tempColor, setTempColor] = useState(value);
    const [format, setFormat] = useState(detectFormat(value));
    const debouncedOnChange = useDebouncedCallback(onChange, debounce);
    useEffect(() => {
        debouncedOnChange.cancel();
        setTempColor(value);
    }, [value, debouncedOnChange]);
    const handleTextChange = (event) => {
        const newValue = event.target.value;
        setTempColor(newValue);
        if (colorString.get(newValue)) {
            const newFormat = detectFormat(newValue);
            onChange(newValue);
            setFormat(newFormat);
        }
    };
    const handleBlur = () => {
        if (!colorString.get(tempColor)) {
            setTempColor(value);
        }
    };
    return (_jsxs(Group, { gap: "xs", justify: "space-between", children: [label && (_jsx(Text, { size: "xs", fw: 500, w: "18ch", children: label })), _jsx(TextInput, { value: tempColor, size: "xs", flex: 1, onChange: handleTextChange, onBlur: handleBlur, disabled: disabled, rightSection: (_jsxs(Popover, { opened: opened, onClose: close, position: "right-start", withArrow: true, shadow: "md", withinPortal: true, closeOnClickOutside: true, children: [_jsx(Popover.Target, { children: _jsx(ActionIcon, { size: "sm", "data-testid": "color-picker-button", onClick: toggle, disabled: disabled, style: { backgroundColor: value } }) }), _jsx(Popover.Dropdown, { ref: dropdownRef, children: _jsxs(Stack, { gap: "xs", children: [_jsx(ColorPicker, { "data-testid": "color-picker", value: tempColor, onChange: (next) => {
                                            setTempColor(next);
                                            debouncedOnChange(next);
                                        }, format: format }), _jsx(Select, { size: "xs", value: format, onChange: (newFormat) => {
                                            if (newFormat) {
                                                setFormat(newFormat);
                                            }
                                        }, data: [
                                            { value: "rgb", label: "RGB" },
                                            { value: "rgba", label: "RGBA" },
                                            { value: "hex", label: "Hex" },
                                            { value: "hsl", label: "HSL" },
                                            { value: "hsla", label: "HSLA" },
                                        ] })] }) })] })) })] }));
}
